(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["article-sources"] && !Shopify.designMode) return;
  try {
    (function () {
    function init(root) {
      const list = root.querySelector('[data-sources-list] .metafield-rich_text_field');
      const toggleWrap = root.querySelector('[data-sources-toggle-wrap]');
      const toggle = root.querySelector('[data-sources-toggle]');
      if (!list || !toggleWrap || !toggle) return;

      const visibleCount = parseInt(root.dataset.visibleCount, 10) || 3;
      const extras = Array.from(list.children).slice(visibleCount);
      if (extras.length === 0) return;

      for (const el of extras) {
        el.setAttribute('hidden', '');
      }
      toggleWrap.removeAttribute('hidden');

      toggle.addEventListener('click', function () {
        for (const el of extras) {
          el.removeAttribute('hidden');
        }
        toggle.setAttribute('aria-expanded', 'true');

        const firstRevealed = extras[0];
        firstRevealed.setAttribute('tabindex', '-1');
        firstRevealed.focus();

        toggleWrap.remove();
      });
    }

    document.querySelectorAll('[data-article-sources]').forEach(init);
  })();
  } catch(e) { console.error(e); }
})();

})();
